(() => {
  const formatMoney = (cents) => new Intl.NumberFormat('zh-TW', {
    style: 'currency', currency: 'TWD', maximumFractionDigits: 0
  }).format(cents / 100);

  const buildMessage = (cart) => {
    const lines = ['【袋鼠國裡的袋熊弟｜商品詢問】', ''];
    cart.items.forEach((item, index) => {
      lines.push(`${index + 1}. ${item.product_title}`);
      if (item.variant_title && item.variant_title !== 'Default Title') lines.push(`款式：${item.variant_title}`);
      lines.push(`數量：${item.quantity}`);
      lines.push(`參考價：${formatMoney(item.final_line_price)}`);
      lines.push('');
    });
    lines.push(`參考小計：${formatMoney(cart.total_price)}`);
    const note = document.querySelector('#Cart-note')?.value?.trim();
    if (note) lines.push(`備註：${note}`);
    lines.push('', '以上價格僅供參考，請協助確認庫存、最終價格與運費，謝謝！');
    return lines.join('\n');
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-wombat-line-inquiry]');
    if (!button) return;
    event.preventDefault();

    const status = document.querySelector('[data-wombat-line-status]');
    const lineId = button.dataset.lineId?.trim();
    if (!lineId) {
      if (status) status.textContent = '店主尚未設定 LINE 官方帳號，請稍後再試。';
      return;
    }

    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart_fetch_failed');
      const cart = await response.json();
      if (!cart.items.length) {
        if (status) status.textContent = '詢問清單目前沒有商品。';
        return;
      }
      const encodedId = encodeURIComponent(lineId.startsWith('@') ? lineId : `@${lineId}`);
      const encodedMessage = encodeURIComponent(buildMessage(cart));
      window.location.href = `https://line.me/R/oaMessage/${encodedId}/?${encodedMessage}`;
    } catch (error) {
      if (status) status.textContent = '暫時無法讀取詢問清單，請重新整理後再試。';
    } finally {
      button.removeAttribute('aria-busy');
    }
  });
})();
